// extracted by mini-css-extract-plugin
export default {"VideoAds":"AdContainer_VideoAds__0tR-M","VideoAdsInner":"AdContainer_VideoAdsInner__wlJUC","AdContainer":"AdContainer_AdContainer__KliWa"};